import React from 'react';

const NearbyContent = ({ locations }) => (
  <>
    {locations.map(({ title, url }) => (
      <a
        href={url}
        title={`${title} RV Rentals`}
        key={title}
        className="flex justify-start w-full pr-6 mb-1 text-sm text-gray-900 md:w-1/3 xs:w-1/2 md:text-base hover:underline underline-offset-2">
        {title}
      </a>
    ))}
  </>
);

export default NearbyContent;
